// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1UHYP","field":"styles_field__3kmyg","fieldCol":"styles_fieldCol__rlH7X","diffCol":"styles_diffCol__TjyVs","diff":"styles_diff__1mF4W"};